import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * UI状態管理ストア
 * サイドメニュー（モバイルメニュー）の開閉状態を管理
 */
export const useUiStore = defineStore('ui', () => {
  // State
  const isSideMenuOpen = ref(false)

  // Actions
  /**
   * サイドメニューの開閉を切り替え
   */
  function toggleSideMenu() {
    isSideMenuOpen.value = !isSideMenuOpen.value
  }

  /**
   * サイドメニューを閉じる
   */
  function closeSideMenu() {
    isSideMenuOpen.value = false
  }

  return {
    // State
    isSideMenuOpen,
    // Actions
    toggleSideMenu,
    closeSideMenu,
  }
})
